import { TbIllustration } from 'components/Figma';
import { useIntl } from 'react-intl';
import { Tile } from 'components/Layout/PageContainer';
import { BenchmarkEmptyStateType } from 'components/benchmarkEmptyStateUtils';

interface BenchmarkEmptyStateProps {
  type: BenchmarkEmptyStateType;
  testId?: string;
}

function BenchmarkEmptyState({ type, testId = '' }: BenchmarkEmptyStateProps) {
  const intl = useIntl();
  const messageIds =
    type === 'historical'
      ? {
          title: 'benchmarking.error.historical_data.title',
          description: 'benchmarking.error.historical_data.description',
        }
      : {
          title: 'benchmarking.error.peer_data.title',
          description: 'benchmarking.error.peer_data.description',
        };

  return (
    <Tile className="flex flex-row h-full justify-center items-center space-x-4 py-16 " data-testid={testId}>
      <TbIllustration name="NoResults" size="md" className="shrink-0" aria-hidden="true" alt="No results" />
      <div className="text-left max-w-[800px]">
        <p className="text-base font-bold">{intl.formatMessage({ id: messageIds.title })}</p>
        <p className="text-base">{intl.formatMessage({ id: messageIds.description })}</p>
      </div>
    </Tile>
  );
}

export { BenchmarkEmptyState };
